module.exports = __webpack_public_path__ + "static/page-4-148ccc09279c4f37c180518417365a22.jpg";